"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cordovaEnv = function () { return ({
    NAME: 'prod',
    ASSET_ROOT: 'assets/',
    BOOKSTORE_ROUTER_BASE_NAME: '/',
    BUILDER_HOST: 'https://builder.rowan.nyc/',
    BUILDER_UI_HOST: 'https://builder-ui.rowan.nyc/',
    PLATFORM: 'ios',
    NATIVE_APPLICATION: true,
    READER_BASE_URL: 'https://builder-assets.rowan.nyc/reader-v-2',
    READER_URL: 'https://reader.rowan.nyc/',
    RUCKSACK_CALLBACK: 'https://reader.rowan.nyc/',
    RUCKSACK_CLIENT_ID: '408e73ae333779e28b1b952d56a06af1039fff49b301324daf0d78ec11d22e17',
    RUCKSACK_HOST: 'https://rucksack.rowan.nyc',
    RUCKSACK_URL: 'https://rucksack.rowan.nyc/',
    RUCKSACK_SECRET: '628e4d6c3de701bad514089af9f33505818e776cd65e0d545d67c968a833dd93',
    BOOKSHELF_URL: 'https://app.rowan.nyc',
    BOOKSHELF_AUTH_URL: 'https://app.rowan.nyc/loadAuthToken.html',
    FEATURE_FLAG_URL: 'https://builder-ui.rowan.nyc/feature-flags.json',
    API_GATEWAY_URL: 'https://gateway.rowan.nyc/',
    SECURE_COOKIES: true,
    COOKIE_DOMAIN: 'rowan.nyc'
}); };
exports.default = cordovaEnv;
